import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterBox = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/newsletter`, { email });
            toast.success(data.message || "Welcome to the Vibetribe.");
            setEmail("");
        } catch {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="newsletter-box"
            className="relative overflow-hidden rounded-2xl border border-amber-500/25 bg-gradient-to-b from-zinc-900/80 to-black/80 backdrop-blur-md p-7 sm:p-9"
        >
            <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-amber-500/10 blur-3xl pointer-events-none" />
            <div className="flex items-center gap-2 text-amber-300">
                <Sparkles size={18} />
                <p className="font-meta text-[11px] tracking-[0.3em] uppercase">Join the Vibetribe</p>
            </div>
            <h3 className="font-display text-xl sm:text-2xl font-semibold text-white mt-3">
                First to hear new music, tour dates & devotionals.
            </h3>
            <p className="text-sm text-zinc-400 mt-2">One email a month. No noise, all signal.</p>
            <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3">
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    data-testid="newsletter-email-input"
                    className="flex-1 bg-black/60 border border-amber-500/25 rounded-full px-5 py-3 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-amber-400/70 focus:ring-2 focus:ring-amber-500/20 transition-all duration-200"
                />
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="newsletter-submit-button"
                    className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-600 text-black font-bold text-sm px-6 py-3 rounded-full hover:shadow-[0_0_25px_rgba(200,151,43,0.4)] hover:scale-105 transition-all duration-200 disabled:opacity-60 disabled:hover:scale-100"
                >
                    <Send size={15} />
                    {loading ? "Joining…" : "Sign Up"}
                </button>
            </form>
        </div>
    );
};

export default NewsletterBox;
